import React, { useEffect, useState } from "react";
import { Loader } from "../Common/Loader/loader";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, Skeleton, Stack } from "@mui/material";
import Vector from "../../Assets/Images/vector.png";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import { AboutMe, FullName, TitleText } from "../EducatorOnBoarding/styles";
import {
  BioData,
  educatorProfilesStyle,
  LinkTag,
  SocialMedia,
  SocialMediaContainer,
  SocialMediaText,
} from "./styles";
import { useParams } from "react-router-dom";
import { fetchEducatorByUrl } from "../../Infrastructure/States/thunks/fetchEducatorThunk";
import Error404 from "../Common/Error404/error404";

export const EducatorProfiles = ({ edit, setEdit, dashboard }) => {
  const { name } = useParams()
  const dispatch = useDispatch()
  const [imageError, setImageError] = useState(false);
  const educatorProfilesSx = educatorProfilesStyle(edit, dashboard)
  const [imageLoaded, setImageLoaded] = useState(false);
  const error = useSelector((state) => state.educator.error);
  const loading = useSelector((state) => state.educator.loading);
  const educatorData = useSelector((state) => state.educator.data);

  const loggedUserData = useSelector((state) => state.userData.data)
  const profile = dashboard ? loggedUserData?.educator?.profile : educatorData?.educator?.profile;
  const aboutMe = profile?.about_me;
  const youtube = profile?.youtube;
  const linkedin = profile?.linkedin;
  const twitter = profile?.twitter;
  const website = profile?.website;
  const profilePicture = profile?.avatar
  const firstName = dashboard ? loggedUserData?.account?.first_name : educatorData?.account?.first_name
  const lastName = dashboard ? loggedUserData?.account?.last_name : educatorData?.account?.last_name
  // Helper function to ensure URLs have a protocol (https://)
  function ensureHttpsProtocol(url) {
    if (url && !url.startsWith("https://")) {
      return "https://" + url;
    }
    return url;
  }
  const websiteUrl = ensureHttpsProtocol(website);
  const youtubeUrl = ensureHttpsProtocol(youtube);
  const linkedinUrl = ensureHttpsProtocol(linkedin);
  const twitterUrl = ensureHttpsProtocol(twitter);
  useEffect(() => {
    if (name) {
      dispatch(fetchEducatorByUrl(name))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name])

  if (error === "Educator not found") {
    return <Error404 />;
  }
  return (
    <>
      {loading ? (
        <Loader height={'100vh'}/>
      ) : (
        <Box sx={educatorProfilesSx.root}
          
        >
          <Grid
            container
            sx={educatorProfilesSx.mainGridBox}
          >
            <Grid
              lg={7}
              md={12}
              sm={12}
              xs={12}
              sx={educatorProfilesSx.subGrid1Box}
              order={{ lg: 1, md: 2, sm: 2, xs: 2 }}
            >
              <Box sx={educatorProfilesSx.subGrid1MainBox}>
                <TitleText color={"primary"} sx={educatorProfilesSx.educatorText}>
                  Educator
                </TitleText>
                <FullName color={"secondary"}>
                  {firstName} {lastName}
                </FullName>
                {edit ? <AboutMe pt={10} color={"primary"} pb={2}>
                  About Me
                </AboutMe>
                  :
                  <Box sx={educatorProfilesSx.aboutMeBox}>
                    <AboutMe color={"primary"} >
                      About Me
                    </AboutMe>
                    {dashboard && <Button variant="contained" color="primary" onClick={() => setEdit(true)}>
                      Edit
                    </Button>}
                  </Box>}
                <BioData sx={{ wordWrap: 'break-word' }} dangerouslySetInnerHTML={{ __html: aboutMe }} />
              </Box>
            </Grid>
            <Grid
              lg={5}
              md={12}
              sm={12}
              xs={12}
              sx={educatorProfilesSx.subGrid2Box}
              order={{ lg: 2, md: 1, sm: 1, xs: 1 }}
            >
              <Box sx={educatorProfilesSx.subGrid2MainBox}>
                <Stack direction="row" spacing={2}>
                  <Box position="relative">
                    <Box sx={educatorProfilesSx.imageBox}>
                      {!imageLoaded && (
                        <Skeleton variant="circular" width={200} height={200} />
                      )}
                      <img
                        src={ imageError
                              ? Vector
                              : profilePicture
                              ? `${profilePicture}?t=${Date.now()}`
                              : Vector}
                        onLoad={() => setImageLoaded(true)}
                        onError={(e) => {
                          setImageError(true)
                          setImageLoaded(true)
                        }}
                        alt="Preview"
                        height={200}
                        width={200}
                        style={{ display: imageLoaded ? 'block' : 'none', borderRadius: '50%' }}
                      />
                    </Box>
                  </Box>
                </Stack>
                <SocialMediaContainer gap={1} mt={3}>
                  {websiteUrl && (
                    <LinkTag href={websiteUrl} target="_blank" rel="noreferrer">
                      <SocialMedia>
                        <InsertLinkIcon fontSize="small" />
                        <SocialMediaText>Website</SocialMediaText>
                      </SocialMedia>
                    </LinkTag>
                  )}
                  {youtubeUrl && (
                    <LinkTag href={youtubeUrl} target="_blank" rel="noreferrer">
                      <SocialMedia>
                        <YouTubeIcon fontSize="small" />
                        <SocialMediaText>Youtube</SocialMediaText>
                      </SocialMedia>
                    </LinkTag>
                  )}
                  {twitterUrl && (
                    <LinkTag href={twitterUrl} target="_blank" rel="noreferrer">
                      <SocialMedia>
                        <TwitterIcon fontSize="small" />
                        <SocialMediaText>Twitter</SocialMediaText>
                      </SocialMedia>
                    </LinkTag>
                  )}
                  {linkedinUrl && (
                    <LinkTag
                      href={linkedinUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <SocialMedia>
                        <LinkedInIcon fontSize="small" />
                        <SocialMediaText>Linkedin</SocialMediaText>
                      </SocialMedia>
                    </LinkTag>
                  )}
                </SocialMediaContainer>
              </Box>
            </Grid>
          </Grid>
        </Box>
      )}
    </>
  );
};
